module.exports = __webpack_public_path__ + "img/logo1.7c42cdd1.png";